const KinsaSafeAreaBlur = () => (
  <div className="fixed top-0 left-0 right-0 z-10 h-(--felt-safe-area-top) bg-white/95 backdrop-blur-[8px]" />
);

export default KinsaSafeAreaBlur;
